var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.2524 14.5999C35.4741 8.24233 29.13 3.79993 21.75 3.79993C14.3691 3.79993 8.02499 8.24233 5.24759 14.5999",
    stroke: "#474747",
    strokeWidth: 3.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.75 12.7999C20.0378 14.474 18.678 16.4737 17.7506 18.6814C16.8232 20.8891 16.3469 23.2601 16.35 25.6546C16.35 26.1046 16.3662 26.551 16.3995 26.9938C18.097 28.6662 19.4443 30.6599 20.363 32.8586C21.2816 35.0574 21.7531 37.417 21.75 39.7999C21.7467 37.4169 22.2182 35.057 23.1368 32.8582C24.0555 30.6593 25.4029 28.6654 27.1005 26.9929C27.2989 24.38 26.9228 21.7553 25.9984 19.3034C25.0741 16.8514 23.624 14.6316 21.75 12.7999V12.7999Z",
    stroke: "#474747",
    strokeWidth: 3.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.74997 21.7999C3.74997 31.7413 11.8086 39.7999 21.75 39.7999C21.7532 37.4169 21.2818 35.0571 20.3631 32.8582C19.4445 30.6593 18.097 28.6654 16.3995 26.9929C13.0337 23.6601 8.48663 21.7934 3.74997 21.7999V21.7999Z",
    stroke: "#474747",
    strokeWidth: 3.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.75 21.7999C39.75 31.7413 31.6914 39.7999 21.75 39.7999C21.7467 37.4169 22.2182 35.0571 23.1368 32.8582C24.0555 30.6593 25.4029 28.6654 27.1005 26.9929C30.4662 23.6601 35.0133 21.7934 39.75 21.7999V21.7999Z",
    stroke: "#474747",
    strokeWidth: 3.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPark);
export default __webpack_public_path__ + "static/media/park.2e9e49eb8d3900dda46427aad078fa25.svg";
export { ForwardRef as ReactComponent };